import { PagePaths } from "@/partner/shared/constants/routes";

/** Карточка зрителя в «Зрителях», как у BuyerEmailCell. */
export const viewerHref = (userId: string): string =>
  `${PagePaths.users}?tab=details&id=${encodeURIComponent(userId)}`;

/**
 * Платежи зрителя: партнёрский поиск платежей ищет по почте или имени
 * покупателя (PaymentsFilterInput.search), не по id платежа.
 */
export const viewerPaymentsHref = (email: string): string =>
  `${PagePaths.payments}?filter[search]=${encodeURIComponent(email)}`;
